import React from "react";

export default function InputSelect({ label, options, value, onChange }: any) {
    return (
        <div className="w-full">
            {label && (
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    {label}
                </label>
            )}
            <select
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none text-sm"
                value={value}
                onChange={onChange}
            >
                {options.map((e, i) => (
                    <option key={`opt-${e.value}-${i}`} value={e.value}>
                        {e.name}
                    </option>
                ))}
            </select>
        </div>
    );
}
